const validate = async(name,value,formData)=>{
    let error = {status:false,message:''}
    let isField = schema[name];
    console.log(`isField`);
    console.log(isField);
    if(isField){
        let validation = isField;
        for(let i=0;i<validation.length;i++){
            switch(validation[i]){
                case 'required':
                if(value==''){
                    error = {status:true,message:`This field is required`};
                    return error;
                }
            }
        }
    }
    return error;
}
const schema = {
    BankName:['required'],
    DisplayName:['required'],
}
export default validate;
